import React from "react";
import {useLocation} from "react-router-dom";

function ErrorPage() {
    const {state} = useLocation()
    const {message} = state;

    return (
        <div className="flex flex-col h-screen flex justify-center items-center">
            <h3 className="font-bold" style={{color: 'red', padding: '10px'}}>ERROR</h3>
            <div style={{color: 'red', border: '1px solid red', padding: '10px', borderRadius: '5px'}}> {message}
            </div>
        </div>
    );
}

export default ErrorPage;